import { Component } from '@angular/core';
import { MapComponent } from "../../../core/map/map.component";
import { SidebarComponent } from "../../../core/sidebar/sidebar.component";
import { WeatherComponent } from "./weather/weather.component";
import { LastRideCardComponent } from "./last-ride-card/last-ride-card.component";
import { AiChatComponent } from "./ai-chat/ai-chat.component";

@Component({
  selector: 'app-dashboard',
  imports: [MapComponent, SidebarComponent, WeatherComponent, LastRideCardComponent, AiChatComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
 /**
 * Komponenta za prikaz glavne nadzorne ploče (dashboarda).
 */
export class DashboardComponent {

}
